var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'shadow-inner-lg rounded-full  flex items-center justify-center overflow-hidden bg-contain',
    _vm.highlight,
    _vm.options,
  ],style:(`background-image: url(${_vm.flag}); background-size: cover; background-position: center;`)},[(_vm.hasPsScore)?_c('p',{staticClass:"score-badge select-none"},[_vm._v(_vm._s(_vm.etScore)),_c('small',[_vm._v("("+_vm._s(_vm.psScore)+")")])]):(_vm.hasEtScore)?_c('p',{staticClass:"score-badge select-none"},[_vm._v(_vm._s(_vm.etScore))]):_c('p',{staticClass:"score-badge select-none"},[_vm._v(_vm._s(_vm.score))])])
}
var staticRenderFns = []

export { render, staticRenderFns }